import {MixForm} from '.'

export const isMaterialDirty = (
  fieldValue: MixForm['material'],
  defaultValue?: MixForm['material']
) => {
  return defaultValue?.materialNumber !== fieldValue?.materialNumber
}

export const isContractDirty = (
  fieldValue: MixForm['contract'],
  defaultValue?: MixForm['contract']
) => {
  return (
    defaultValue?.contractNumber?.replace(/^0+/, '') !== fieldValue?.contractNumber?.replace(/^0+/, '') ||
    defaultValue?.contractItemPositionNumber !== fieldValue?.contractItemPositionNumber
  )
}
